import React from 'react';
import { motion } from 'framer-motion';
import { 
  UsersIcon, 
  UserIcon
} from '@heroicons/react/24/outline';

const TeamTypeSelection = ({ formData, updateFormData, onNext }) => {
  const teamTypes = [
    {
      id: 'team',
      title: 'With my team',
      description: 'Collaborate on projects, share clients, manage workflows together',
      icon: UsersIcon,
      features: [
        'Shared projects and client database',
        'Team task assignments',
        'Collaborative editing',
        'Team analytics dashboard'
      ]
    },
    {
      id: 'individual',
      title: 'On my own',
      description: 'Focus on personal projects, portfolio, and client management',
      icon: UserIcon,
      features: [
        'Personal portfolio management',
        'Individual client tracking',
        'Private project organization',
        'Personal analytics'
      ]
    }
  ];

  const handleSelection = (teamType) => {
    updateFormData({ teamType: teamType.id });
    onNext();
  };

  return (
    <div className="px-8 py-12 max-w-4xl mx-auto text-center">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="mb-12"
      >
        <h2 className="text-4xl font-bold text-white mb-6">
          Welcome to Klorah for {formData.useCase}
        </h2>
        <p className="text-xl text-white/70">
          This helps customize your experience
        </p>
      </motion.div>

      <div className="grid md:grid-cols-2 gap-8">
        {teamTypes.map((teamType, index) => (
          <motion.button
            key={teamType.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            onClick={() => handleSelection(teamType)}
            className="p-8 rounded-2xl border border-white/10 hover:border-brand hover:shadow-lg hover:shadow-orange-500/20 transition-all duration-300 text-left group bg-white/5 hover:bg-white/10"
          >
            <div className="flex items-center gap-6 mb-6">
              <div className="p-4 rounded-xl bg-gradient-to-br from-[#FFB27D] to-[#FF9D5C] shadow-lg">
                <teamType.icon className="w-8 h-8 text-white" />
              </div>
              <div>
                <h3 className="text-2xl font-semibold text-white group-hover:text-brand transition-colors">
                  {teamType.title}
                </h3>
              </div>
            </div>
            
            <p className="text-base text-white/70 mb-6">
              {teamType.description}
            </p>

            <ul className="space-y-3">
              {teamType.features.map((feature, i) => (
                <li key={i} className="flex items-center gap-3 text-sm text-white/90">
                  <div className="w-2 h-2 bg-brand rounded-full" />
                  {feature}
                </li>
              ))}
            </ul>
          </motion.button>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3 }}
        className="mt-12 text-base text-white/50"
      >
        Don't worry, you can invite team members later or change this setting
      </motion.div>
    </div>
  );
};

export default TeamTypeSelection;